<template>
  <div class="bg-white">
    <navbar />
    <vue-page-transition name="fade" class="lg:pt-24 md:pt-24 pt-20">
      <router-view></router-view>
    </vue-page-transition>
    <FeedbackFooter />
  </div>
</template>
<script>
import Navbar from "@/navbar/Navbar";
import FeedbackFooter from "@/views/footer/FeedbackFooter";
export default {
  components: {
    Navbar,
    FeedbackFooter,
  },
  async mounted() {
    await this.$store.dispatch("admin/getProject");
  },
};
</script>
